import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import Amplify from 'aws-amplify';
import awsconfig from './awsconfigExport';
import { Auth } from 'aws-amplify';
import TheErrorLayout from './containers/TheErrorLayout';
import { page } from './constants/page';
import { connect } from 'react-redux';
import Modal from './components/modal/Modal';

Amplify.configure(awsconfig);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const CompleteNewPassword = React.lazy(() => import('./views/pages/login/CompleteNewPassword'));
const Logout = React.lazy(() => import('./views/pages/logout/Logout'));
const Reset = React.lazy(() => import('./views/pages/reset/Reset'));
const ForgotPasswordVerification = React.lazy(() =>
  import('./views/pages/reset/ForgotPasswordVerification')
);
const ChangePassword = React.lazy(() => import('./views/pages/change-password/ChangePassword'));

class App extends Component {
  // mod@ccs start ---
  state = {
    isAuthenticated: false,
    isAuthenticating: true,
    user: null,
  };

  setAuthStatus = (authenticated) => {
    this.setState({ isAuthenticated: authenticated });
  };

  setUser = (user) => {
    this.setState({ user: user });
  };

  async componentDidMount() {
    try {
      await Auth.currentSession();
      this.setAuthStatus(true);
      const user = await Auth.currentAuthenticatedUser();
      this.setUser(user);
    } catch (error) {
      console.log(error);
    }

    this.setState({ isAuthenticating: false });
  }
  //mod@ccs end ---

  render() {
    // mod@ccs ---
    const authProps = {
      isAuthenticated: this.state.isAuthenticated,
      user: this.state.user,
      setAuthStatus: this.setAuthStatus,
      setUser: this.setUser,
    };
    const { show, textMsg } = this.props;

    // mod@ccs ---
    return (
      // mod@ccs start ---
      !this.state.isAuthenticating && (
        // mod@ccs end ---
        <>
          <HashRouter>
            <React.Suspense fallback={loading}>
              <Switch>
                <Route
                  exact
                  path="/login"
                  name="Login Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : this.state.isAuthenticated ? (
                      <TheLayout {...props} auth={authProps} />
                    ) : page.some((item) => window.location.href.includes(item)) ||
                      !window.location.host.includes(process.env.REACT_APP_DOMAIN) ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <Login {...props} auth={authProps} />
                    )
                  }
                />
                <Route
                  exact
                  path="/completeNewPassword"
                  name="CompleteNewPassword Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <CompleteNewPassword {...props} auth={authProps} />
                    )
                  }
                />
                <Route
                  exact
                  path="/logout"
                  name="Logout Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : this.state.isAuthenticated ? (
                      <Logout {...props} auth={authProps} />
                    ) : (
                      <TheLayout {...props} auth={authProps} />
                    )
                  }
                />
                <Route
                  exact
                  path="/reset"
                  name="Reset Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <Reset {...props} auth={authProps} />
                    )
                  }
                />
                <Route
                  exact
                  path="/forgotPasswordVerification"
                  name="ForgotPasswordVerification Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <ForgotPasswordVerification {...props} auth={authProps} />
                    )
                  }
                />
                <Route
                  exact
                  path="/changePassword"
                  name="ChangePassword Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : this.state.isAuthenticated ? (
                      <ChangePassword {...props} auth={authProps} />
                    ) : (
                      <TheLayout {...props} auth={authProps} />
                    )
                  }
                />
                <Route
                  path="/"
                  name="Home"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : this.state.isAuthenticated ? (
                      <TheLayout {...props} auth={authProps} />
                    ) : page.some((item) => window.location.href.includes(item)) ||
                      !window.location.host.includes(process.env.REACT_APP_DOMAIN) ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <Login {...props} auth={authProps} />
                    )
                  }
                />
              </Switch>
            </React.Suspense>
          </HashRouter>
          {show && (
            <Modal
              show={show}
              onOK={() => {
                this.props.changeModalState({
                  show: false,
                  textMsg: '',
                });
              }}
              text={textMsg}
              onClose={() => {
                this.props.changeModalState({
                  show: false,
                  textMsg: '',
                });
              }}
            />
          )}
        </>
      )
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  changeModalState: (payload) => dispatch({ type: 'set', msgModal: payload }),
});
function mapStateToProps(state) {
  const { show, textMsg } = state.msgModal;
  return { show, textMsg };
}
export default connect(mapStateToProps, mapDispatchToProps)(App);
